export const SET_PAGE_CONTEXT = "SET_PAGE_CONTEXT";
export const TOGGLE_FILTER = "TOGGLE_FILTER";
export const TOGGLE_SEARCH = "TOGGLE_SEARCH";
export const CHANGE_TAB = "CHANGE_TAB";
